import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import { CONSTANT } from '../../../../utils/constants';
import MainImageForm from '../../common/image/MainImageForm';

function EventManager({ isOpen, onClose, event, onUpdate, loading, onCreate }) {
  const [title, setTitle] = useState('');
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [placeName, setPlaceName] = useState('');
  const [organizer, setOrganizer] = useState('');
  const [description, setDescription] = useState('');
  const [maxAttendeesNb, setMaxAttendeesNb] = useState(null);
  const [image, setImage] = useState(undefined);
  const [tag, setTag] = useState('');
  const [infos, setInfos] = useState('');
  const [weezeventRef, setWeezeventRef] = useState('');

  useEffect(() => {
    if (event) {
      setTitle(event.title);
      setStartDate(new Date(event.start_dt));
      setEndDate(new Date(event.end_dt));
      setPlaceName(event.place_name);
      setOrganizer(event.organizer);
      setDescription(event.description);
      setMaxAttendeesNb(event.max_attendee_nb);
      setImage(event.image);
      setTag(event.tag);
      setInfos(event.infos);
      setWeezeventRef(event.weezevent_ref);
    } else {
      setTitle('');
      setStartDate(undefined);
      setEndDate(undefined);
      setPlaceName('');
      setOrganizer('');
      setDescription('');
      setMaxAttendeesNb(null);
      setImage(undefined);
      setTag('');
      setInfos('');
      setWeezeventRef('');
    }
  }, [event, isOpen]);

  const handleValidate = () => {
    const eventPayload = {
      title,
      start_dt: startDate,
      end_dt: endDate,
      place_name: placeName,
      organizer,
      description,
      max_attendee_nb: maxAttendeesNb,
      image: image?.id,
      tag,
      infos,
      weezevent_ref: weezeventRef
    };
    event ? onUpdate(eventPayload) : onCreate(eventPayload);
  };

  const formIsValid = () => {
    return title.length > 3 && startDate && endDate && placeName.length > 3 && organizer.length > 3;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${event ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${event ? 'Modifier' : 'Ajouter'} un Évènement`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput key="title" label={"Titre de l'évènement"} required isValid={title.length > 3}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre de l'évènement"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <div className="grid grid-cols-2 gap-3">
            <FormInput key="start_dt" label={'Date de début'} required isValid={startDate}>
              <Calendar
                id="start_dt"
                onChange={(e) => setStartDate(e.value)}
                placeholder="Veuillez selectionner la date de début"
                value={startDate}
                locale="fr"
                showTime
                hourFormat="24"
                stepMinute={10}
              />
            </FormInput>
            <FormInput key="end_dt" label={'Date de fin'} required isValid={endDate}>
              <Calendar
                id="end_dt"
                onChange={(e) => setEndDate(e.value)}
                placeholder="Veuillez selectionner la date de fin"
                value={endDate}
                locale="fr"
                showTime
                hourFormat="24"
                stepMinute={10}
              />
            </FormInput>
          </div>

          <FormInput
            key="place_name"
            label={"Lieu de l'évènement"}
            required
            isValid={placeName.length > 3}>
            <InputText
              id="place_name"
              value={placeName}
              maxLength={300}
              placeholder="Veuillez saisir le lieu de l'évènement"
              onChange={(e) => setPlaceName(e.target.value)}
            />
          </FormInput>
          <FormInput
            key="organizer"
            label={"Organisateur de l'évènement"}
            required
            isValid={organizer.length > 3}>
            <InputText
              id="organizer"
              value={organizer}
              maxLength={300}
              placeholder="Veuillez saisir l'organisateur de l'évènement"
              onChange={(e) => setOrganizer(e.target.value)}
            />
          </FormInput>
          <FormInput key="max_attendee_nb" label={'Nombre de participant maximum'}>
            <InputNumber
              id="max_attendee_nb"
              value={maxAttendeesNb}
              onChange={(e) => setMaxAttendeesNb(e.value)}
              mode="decimal"
              showButtons
            />
          </FormInput>
          <FormInput key="weezevent_ref" label={'Reference Weezevent'}>
            <InputText
              id="weezevent_ref"
              value={weezeventRef}
              maxLength={300}
              placeholder="champs 'href' du code d'intégration fourni par Weezevent"
              onChange={(e) => setWeezeventRef(e.target.value)}
            />
          </FormInput>

          <FormInput key="type" label={'Type'} required isValid={tag?.length > 3}>
            <Dropdown
              value={tag}
              onChange={(e) => setTag(e.value)}
              options={CONSTANT.maisonmousse.tags}
              optionLabel="label"
              placeholder="Choisissez un tag"
              className="w-full md:w-14rem"
            />
          </FormInput>
          <FormInput key="description" label={'Description'}>
            <RichTextEditor
              value={description}
              onChange={(value) => {
                setDescription(value);
              }}
            />
          </FormInput>
          <FormInput key="infos" label={'Infos pratiques'}>
            <RichTextEditor
              value={infos}
              onChange={(value) => {
                setInfos(value);
              }}
            />
          </FormInput>
          <MainImageForm mainImage={image} setMainImage={setImage} />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default EventManager;
